/** Shared ink for globe + pastiradit. Stay grey 220; never white 255. */

export const ALPHA_MIN = 0.45;
export const ALPHA_MAX = 0.72;
export const SHADOW_ALPHA = 0.28;

/**
 * Lambert light in globe NDC: +x right, +y up, +z toward camera.
 * Upper-left; text extrusion casts the opposite way (down-right on canvas).
 */
export const LIGHT_X = -0.42;
export const LIGHT_Y = 0.48;
export const LIGHT_Z = 0.76;

const _shadowLen = Math.hypot(-LIGHT_X, LIGHT_Y);
/** Canvas-space unit shadow direction (y down). */
export const SHADOW_DIR_X = -LIGHT_X / _shadowLen;
export const SHADOW_DIR_Y = LIGHT_Y / _shadowLen;

export const FONT_STACK =
  'ui-monospace, "Cascadia Code", "JetBrains Mono", Menlo, Consolas, monospace';

export function ink(alpha: number): string {
  return `rgba(220, 220, 220, ${alpha})`;
}
